import React, { useState,useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
export default function PriceCalculator() {


  useEffect(() => {
    document.title='Package Price Calculator'
  }, [])

  const [hotel_price_in_makkah, sethotel_price_in_makkah] = useState()
  const [hotel_price_in_madinah, sethotel_price_in_madinah] = useState()
  const [extra_charges_in_makkah, setextra_charges_in_makkah] = useState()
  const [extra_charges_in_madinah, setextra_charges_in_madinah] = useState()
  const [visa_cost, setvisa_cost] = useState()
  const [exchange_rate, setexchange_rate] = useState()
  const [profit_margin, setprofit_margin] = useState()
  const [airline_ticket_price, setairline_ticket_price] = useState()
  const [nights_in_makkah, setnights_in_makkah] = useState()
  const [nights_in_madinah, setnights_in_madinah] = useState()
  const [room_multiplier, setroom_multiplier] = useState()
  const [total, settotal] = useState(0)



  const clearForm = () => {
    sethotel_price_in_makkah(0)
    sethotel_price_in_madinah(0)
    setextra_charges_in_makkah(0)
    setextra_charges_in_madinah(0)
    setvisa_cost(0)
    setexchange_rate(0)
    setprofit_margin(0)
    setairline_ticket_price(0)
    setnights_in_makkah(0)
    setnights_in_madinah(0)
    setroom_multiplier(0)
    settotal(0)
  }


  const calculateTotal = (e) => {
    e.preventDefault();
    
    // Calculate hotel costs in SAR
    const makkahHotelCost = (hotel_price_in_makkah * nights_in_makkah) / room_multiplier;
  const madinahHotelCost = (hotel_price_in_madinah * nights_in_madinah) / room_multiplier;
  
    // Total hotel cost in SAR
    const totalHotelCostSAR = makkahHotelCost + madinahHotelCost;
    
    // Convert hotel cost to PKR
    const totalHotelCostPKR = totalHotelCostSAR * exchange_rate;
    
    const totalExtraChargesInMakkah=extra_charges_in_makkah*exchange_rate
    const totalExtraChargesInMadinah=extra_charges_in_madinah*exchange_rate



    
    // Calculate total package price
    const totalPackagePrice = 
    totalHotelCostPKR + 
     (visa_cost * exchange_rate) + 
      Number(airline_ticket_price) + 
      Number(profit_margin) + 
      totalExtraChargesInMakkah+
      totalExtraChargesInMadinah
    
    // Round to nearest integer
    settotal(Math.round(totalPackagePrice));
  }


  const collapsed = useSelector((state) => state.collapsed.collapsed);
  return (
    <div className={`${collapsed ? "collapsed mt-5 " : "main mt-5"}`}>
      <div className="container-fluid bg-none my-0 mt-4">
        <div className="row px-2 mt-5 pt-4">
          <div className="col-md-12 data_table p-2 pb-0 new_package">
            <div className="card p-4 border-0">
              <div className="row">
                <div className="d-flex justify-content-between px-1 info_header">
                  <div className="left">
                    <h4 className="mb-3">Umrah Package Price Calculator</h4>
                  </div>
                </div>
                <hr />
              </div>


              <form onSubmit={calculateTotal}>
                <div className="row mb-3 mt-2">
                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Hotel Price Per Night in Makkah (SAR)
                    </label>
                    <input type="number" value={hotel_price_in_makkah} onChange={(e) => sethotel_price_in_makkah(e.target.value)} required/>
                  </div>
                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Hotel Price Per Night in Madinah (SAR)
                    </label>
                    <input type="number" value={hotel_price_in_madinah} onChange={(e) => sethotel_price_in_madinah(e.target.value)} required/>
                  </div>
                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Extra Charges in Makkah (SAR)
                    </label>
                    <input type="number" value={extra_charges_in_makkah} onChange={(e) => setextra_charges_in_makkah(e.target.value)} required/>
                  </div>
                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Extra Charges in Madinah (SAR)
                    </label>
                    <input type="number" value={extra_charges_in_madinah} onChange={(e) => setextra_charges_in_madinah(e.target.value)} required/>
                  </div>

                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Visa Cost (SAR)
                    </label>
                    <input type="number" value={visa_cost} onChange={(e) => setvisa_cost(e.target.value)} required/>
                  </div>

                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Exchange Rate (PKR per SAR)
                    </label>
                    <input type="number" value={exchange_rate} onChange={(e) => setexchange_rate(e.target.value)} required/>
                  </div>

                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Profit Margin (PKR)
                    </label>
                    <input type="number" value={profit_margin} onChange={(e) => setprofit_margin(e.target.value)} required/>
                  </div>

                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Airline Ticket (PKR)
                    </label>
                    <input type="number" value={airline_ticket_price} onChange={(e) => setairline_ticket_price(e.target.value)} required/>
                  </div>

                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Nights in Makkah
                    </label>
                    <input type="number" value={nights_in_makkah} onChange={(e) => setnights_in_makkah(e.target.value)} required/>
                  </div>

                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Nights in Madinah
                    </label>
                    <input type="number" value={nights_in_madinah} onChange={(e) => setnights_in_madinah(e.target.value)} required/>
                  </div>

                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Room Multiplier
                    </label>
                    <input type="number" value={room_multiplier} onChange={(e) => setroom_multiplier(e.target.value)} required/>
                  </div>
                </div>
                <div className="row justify-content-center my-3">

                  <div className="col-md-12 text-center">
                    <button className='calculate_btn m-1' type='submit'>Calculate</button>
                    <Link className='btn clear_btn m-1' onClick={()=>clearForm()}>Clear</Link>
                  </div>

                  <div className="col-md-3 border p-3 mt-3 rounded pricing">
                    {/* <h5 className='text-center'>Total Package Price</h5> */}
                    <h2 className='text-center my-auto'><strong>Total:</strong> {total?total.toLocaleString():0}  PKR</h2>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
